export const Get = async (url) => {
    try {
        const creator = getCreatorIdFromLocalStorage();

        const response = await fetch(url, {
            headers: {
                Authorization: process.env.REACT_APP_TOKEN,
                creator,
            },
        });

        const responseData = await response.json();

        if (response.status !== 200) {
            const error = responseData.message ?? responseData.error;
            throw new Error(error);
        }

        return responseData;
    } catch (error) {
        throw new Error(error);
    }
};
export const Post = async (url, data) => {
    const creator = getCreatorIdFromLocalStorage();
    const isFormData = data instanceof FormData;

    // Configura os cabeçalhos básicos
    const headers = {
        Authorization: process.env.REACT_APP_TOKEN,
        creator,
    };

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
        data = JSON.stringify(data); // Serializa apenas se não for FormData
    }

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: data,
        });

        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || 'Erro na requisição');
        }

        return responseData;
    } catch (error) {
        throw new Error(error);
    }
};

export const Patch = async (url, data) => {
    const creator = getCreatorIdFromLocalStorage();

    const isFormData = data instanceof FormData;
    const headers = {
        Authorization: process.env.REACT_APP_TOKEN,
        creator,
    };

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
        data = JSON.stringify(data);
    }

    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers: headers,
            body: data,
        });

        if (!response.ok) {
            const responseData = await response.json();
            throw new Error(responseData);
        }

        return response.json();
    } catch (error) {
        throw new Error(error);
    }
};

export const Put = async (url, data) => {
    const creator = getCreatorIdFromLocalStorage();

    const isFormData = data instanceof FormData;
    const headers = {
        Authorization: process.env.REACT_APP_TOKEN,
        creator,
    };

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
        data = JSON.stringify(data);
    }

    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: headers,
            body: data,
        });

        if (!response.ok) {
            const responseData = await response.json();
            throw new Error(responseData);
        }

        return response.json();
    } catch (error) {
        throw new Error(error);
    }
};

export const Download = async (url, data) => {
    const creator = getCreatorIdFromLocalStorage();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                Authorization: process.env.REACT_APP_TOKEN,
                'Content-Type': 'application/json',
                creator,
            },
            body: JSON.stringify(data),
        });

        if (response.status !== 200) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Erro no download');
        }

        return await response.blob();
    } catch (error) {
        throw new Error(error.message || 'Erro no download');
    }
};

export const Delete = async (url, data) => {
    const creator = getCreatorIdFromLocalStorage();

    const queryString = new URLSearchParams(data).toString();
    const fullUrl = `${url}?${queryString}`;

    try {
        const response = await fetch(fullUrl, {
            headers: {
                Authorization: process.env.REACT_APP_TOKEN,
                creator,
            },
            method: 'DELETE',
        });

        const responseData = await response.json();

        if (response.status !== 200) {
            throw new Error(responseData);
        }

        return responseData;
    } catch (error) {
        throw new Error(error);
    }
};

export const getUserKey = () => {
    const isDevEnvironment = window.location.hostname.includes('dev');
    return isDevEnvironment ? 'dev_creator' : 'prod_creator';
};

export const getCreatorIdFromLocalStorage = () => {
    const storedCreator = localStorage.getItem(getUserKey());
    if (storedCreator) {
        try {
            const creator = JSON.parse(storedCreator);
            return creator.id ? creator.id : null;
        } catch (e) {
            throw new Error(e);
        }
    } else {
        return null;
    }
};
